import { IconName } from "@zenchef/icomoon";
import Button, { ButtonProps } from "../Button/Button";
import Icon from "../Icon/Icon";
import Badge from "../Badge/Badge";
import {
  aromaNavButton,
  AromaNavButtonVariantProps,
} from "@zenchef/styled-system/recipes";
import { cx } from "@zenchef/styled-system/css";
import { FC, PropsWithChildren } from "react";

export interface NavButtonProps
  extends AromaNavButtonVariantProps,
    PropsWithChildren,
    Pick<ButtonProps, "disabled" | "asChild" | "onClick"> {
  iconName?: IconName;
  showBadge?: boolean;
  className?: string;
}

const NavButton: FC<NavButtonProps> = ({
  iconName,
  disabled,
  showBadge,
  className,
  children,
  ...props
}) => {
  const [variants, restProps] = aromaNavButton.splitVariantProps(props);
  const aromaClassName = aromaNavButton(variants);

  return (
    <Button
      hierarchy="brand-reversed-subtler"
      disabled={disabled}
      iconOnly
      className={cx(aromaClassName.root, className)}
      {...restProps}
    >
      {iconName ? <Icon name={iconName} /> : null}
      {showBadge ? (
        <Badge
          className={aromaClassName.badge}
          chip
          icon={false}
          function="error"
        />
      ) : null}
      {children}
    </Button>
  );
};

export default NavButton;
